import {
  Grid,
  makeStyles,
  Typography,
  Paper,
  Button
} from "@material-ui/core";
import { ValidatorForm } from "react-material-ui-form-validator";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import { fetchUsuario } from "../../actions/usuarios/usuarios";
import { Firma } from "../configuracion/usuarios/Firma";
import ReactSelect from "react-select";
import { fetchEspecialidades } from '../../actions/especialidades';
import TextField from "@material-ui/core/TextField";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    marginTop: theme.spacing(2),
  },
  rootDatos: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: theme.palette.background.paper,
    padding: 10,
    marginTop: 20,
  },
  button: {
    marginTop: theme.spacing(2),
    float: "right",
  },
  input: {
    display: "none",
  },
}));

const CredencialesRecetasDigitalesUsuario = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const idUsuario = useSelector((state) => state.auth.idUsuario);
  const { usuarioSeleccionado } = useSelector((state) => state.usuarios);
  const especialidades = useSelector((state) => state.especialidades);

  const onClickCancelarHandler = () => {
    history.push("/");
  };

  const handleSubmit = (event) => {

  };

  useEffect(() => {
    dispatch(fetchEspecialidades(true))
    dispatch(fetchUsuario(idUsuario))

  }, [dispatch, idUsuario]);

  return (
    <div className={classes.root}>
      <Grid
        container
        spacing={1}
        direction="row"
        justify="center"
        alignItems="center"
      >
        <Grid item xs={12}>
          <Typography
            variant="h5"
            style={{
              margin: "2rem 0",
              fontStyle: "italic",
              textAlign: "center",
              color: "white",
            }}
          >
            Credenciales para Recetas Digitales
          </Typography>
        </Grid>
        <Grid item xs={1} sm={2} lg={4} />
        <Grid item xs={8} sm={8} lg={4}>
          <Paper
            component="form"
            style={{
              padding: "2px 4px",
              alignItems: "center",
              boxShadow: "none",
              /* width: "50%", */
              paddingBottom: "2rem",
            }}
          >
            <ValidatorForm onSubmit={handleSubmit}>

              <Grid container spacing={1}>
                <Grid item xs={12} md={4} style={{ marginLeft: 35 }} >
                  <TextField
                    margin="normal"
                    label="Matrícula Nacional"
                    name="matriculaNac"
                    value={usuarioSeleccionado?.matriculaNac}
                    disabled={true}
                    autoComplete="off"
                    inputProps={{ maxLength: 50, style: { textTransform: "uppercase" } }}
                    InputLabelProps={{ shrink: true }} 
                  />
                </Grid>
                <Grid item xs={12} md={4} style={{ marginLeft: 20 }} >
                  <TextField
                    margin="normal"
                    label="Matrícula Provincial"
                    name="matriculaProv"
                    value={usuarioSeleccionado?.matriculaProv}
                    disabled={true}
                    autoComplete="off"
                    inputProps={{ maxLength: 50, style: { textTransform: "uppercase" } }}
                    InputLabelProps={{ shrink: true }} 
                  />
                </Grid>
              </Grid>

              <Grid container spacing={1}>
                <Grid item sm={8} style={{ marginTop: 0, marginLeft: 30 }}>
                  <Typography variant="button">Especialidades</Typography>
                  <ReactSelect
                    isDisabled={true}
                    value={
                      usuarioSeleccionado?.especialidadesUsuarios?.map((item) => {
                        const especialidad = especialidades?.items.find(
                          (e) => e.idEspecialidades === item
                        );
                        return especialidad
                          ? {
                            value: especialidad.idEspecialidades,
                            label: especialidad.descripcionEspecialidades,
                          }
                          : undefined;
                      }) ?? []
                    }
                    isMulti
                    name="colors"
                    //options={especialidadesOptions}
                    placeholder="Seleccione Especialidades..."
                    styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                    menuPosition="fixed"
                  />
                </Grid>
              </Grid>

              <Grid container spacing={1} >
                <Grid item xs={4} style={{ marginTop: 10, marginLeft: 30 }}>
                  <Firma />
                </Grid>
              </Grid>

              <Grid container style={{ marginTop: "1rem", marginLeft: "4rem" }}>
                <Grid item xs={4}>
                  <Button
                    style={{ marginRight: "-4rem" }}
                    variant="contained"
                    color="primary"
                    onClick={onClickCancelarHandler}
                    className={classes.button}
                  >
                    Cerrar
                  </Button>
                </Grid>
              </Grid>
            </ValidatorForm>
          </Paper>
        </Grid>
        <Grid item xs={1} sm={2} lg={4} />
      </Grid>
    </div>
  );
};

export default CredencialesRecetasDigitalesUsuario;
